import { CURRICULUMS, StudentServicePath, TOPICS } from "utils/constants";
import Topics from "./Topics";
import permissions from "app/permissions";

export const resources = {
  name: StudentServicePath + TOPICS + "/" + CURRICULUMS + "/:id",
  title: "Теми",
  custom: <Topics />,
  permission: permissions.canPreviewCurriculumDisciplineTopics,
};
